import { render, staticRenderFns } from "./ClientUserHeader.vue?vue&type=template&id=471f059f&scoped=true"
import script from "./ClientUserHeader.vue?vue&type=script&lang=js"
export * from "./ClientUserHeader.vue?vue&type=script&lang=js"
import style0 from "./ClientUserHeader.vue?vue&type=style&index=0&id=471f059f&scoped=true&lang=css"
import style1 from "./ClientUserHeader.vue?vue&type=style&index=1&id=471f059f&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471f059f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('471f059f')) {
      api.createRecord('471f059f', component.options)
    } else {
      api.reload('471f059f', component.options)
    }
    module.hot.accept("./ClientUserHeader.vue?vue&type=template&id=471f059f&scoped=true", function () {
      api.rerender('471f059f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/businessHome/components/ClientUserWrap/ClientUserHeader.vue"
export default component.exports